import { useQuery } from '@tanstack/react-query';
import type { SynchronousQueryConfig } from 'lib/react-query';
import queryString from 'query-string';
import { apiClient } from 'lib/api';
import queryKeys from '../api/queryKeys';
import type { CreativeEntry } from 'types/shared';

export type UploadDate = 'last_week' | 'last_2_weeks' | '1_month' | 'all';

export interface CreativeParams {
  query?: string[];
  app?: string;
  ad_type?: string;
  network?: string;
  locale?: string;
  hypothesis?: string[];
  customer?: string;
  flow?: string[];
  technology?: string[];
  status?: string;
  search?: string;
  upload_date?: UploadDate;
  tpc_finish_date?: string;
}

export const getCreatives = async (
  { params }: { params: CreativeParams },
  signal?: AbortSignal,
): Promise<CreativeEntry[]> => {
  const res = await apiClient.get<CreativeEntry[]>(
    (queryKeys.allCreatives as string[]).join('/'),
    {
      params,
      signal,
      paramsSerializer: (prms) =>
        queryString.stringify(prms, { arrayFormat: 'comma' }),
    },
  );
  return res.data;
};

interface UseCreativesOptions {
  params: CreativeParams;
  config?: SynchronousQueryConfig<typeof getCreatives, CreativeEntry[]>;
}

export const useCreatives = ({ params, config }: UseCreativesOptions) => {
  return useQuery({
    staleTime: 0,
    refetchOnMount: true,
    ...config,
    queryFn: ({ signal }) => getCreatives({ params }, signal),
    queryKey: queryKeys.creatives<CreativeParams>(params),
  });
};
